import Hafiz from "../components/yayla-course/Hafiz";
import MainArabicMadrasa from "../components/yayla-course/MainArabicMadrasa";

export const Contact = () => {
  return <></>;
};

export default Contact;
